import { Icon } from "@mui/material";
import { BsTicketPerforatedFill, BsWalletFill } from "react-icons/bs";
import { FaUserCog } from "react-icons/fa";
import { GiSettingsKnobs } from "react-icons/gi";

const customerProRoute = [
  // { type: "title", title: "Dashboard" },
  {
    type: "collapse",
    name: "Dashboards",
    key: "cst",
    noCollapse: true,
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "Dashboard",
        key: "dash",
        route: "cst/dash",
      },
    ],
  },
  // { type: "title", title: "Ticket" },
  {
    type: "collapse",
    name: "Ticket",
    key: "ADM-Ticket",
    noCollapse: true,
    icon: <BsTicketPerforatedFill />,
    collapse: [
      {
        name: "My Tickets",
        key: "pending-tickets",
        route: "ADM-Ticket/pending-tickets",
      },
      {
        name: "New Ticket",
        key: "new-ticket",
        route: "ADM-Ticket/new-ticket",
      },
    ],
  },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    icon: <BsWalletFill />,
    noCollapse: true,
    collapse: [
      {
        name: "My Payment Methods",
        key: "customer-payment-methods",
        route: "wallet/customer-payment-methods",
      },
    ],
  },
  {
    type: "collapse",
    name: "Account",
    key: "account",
    icon: <Icon>account_circle</Icon>,
    noCollapse: true,
    collapse: [
      /* {
        name: "Account Management",
        key: "account-management",
        route: "account/management",
      }, */
      {
        name: "Invoices",
        key: "invoices",
        route: "account/invoices",
      },
      /* {
        name: "Legacy Invoices",
        key: "my-invoices",
        route: "account/my-invoices",
      }, */
      {
        name: "Statements",
        key: "statements",
        route: "account/statements",
      },
    ],
  },
  {
    type: "collapse",
    name: "Configurations",
    key: "ADM-APPCONFIG",
    icon: <GiSettingsKnobs />,
    collapse: [
      {
        name: "Reset Password",
        key: "reset_password",
        route: "ADM-APPCONFIG/reset_password",
      },
    ],
  },
  {
    type: "collapse",
    name: "User Management",
    key: "USER_MGMT",
    icon: <FaUserCog />,
    collapse: [
      {
        name: "New UID Entry",
        key: "new_uid",
        route: "USER_MGMT/new_uid",
      },
      {
        name: "UID Directory",
        key: "uid_directory",
        route: "USER_MGMT/uid_directory",
      },
    ],
  },
];

export default customerProRoute;
